module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/depth_views/01-3ad62b9c366e36472eaa69cde7b945cf.png";